// 浏览器截流机制影响，设置10000效果不绝对生效
export const loadReCaptcha = () => {
  return Promise.race([
    new Promise((resolve, reject) => {
      // 已经存在 grecaptcha
      if (window.grecaptcha) return resolve(window.grecaptcha)
      // 如果已有 script，移除再插入新的
      const existingScript = document.querySelector('script[src*="recaptcha/enterprise.js"]')
      if (existingScript) {
        existingScript.remove()
      }
      const script = document.createElement("script")
      script.src = `https://www.google.com/recaptcha/enterprise.js?render=6Ld88nQrAAAAAHHD-OtUpGI0zN65ybxk3D2pcij5`
      script.async = true
      script.onload = () => {
        resolve(window.grecaptcha)
      }
      script.onerror = () => {
        // eslint-disable-next-line prefer-promise-reject-errors
        reject("failed")
      }

      document.head.appendChild(script)
    }),
    // eslint-disable-next-line prefer-promise-reject-errors, promise/param-names
    new Promise((_, reject) => setTimeout(() => reject("failed"), 10000))
  ])
}
